module.exports = __webpack_public_path__ + "img/comp_chassis.744931fa.jpg";